// views/Admin/Bonuses/components/FilterButton/FilterButton.tsx
import styles from './FilterButton.module.css';

interface FilterButtonProps {
  name: string;
  onClick: () => void;
  active: boolean;
  color: string;
}

const FilterButton = ({ name, onClick, active, color }: FilterButtonProps) => (
  <button
    className={`${styles.buttonFilter} ${active ? styles.active : styles.inactive}`}
    onClick={onClick}
    style={{ borderColor: active ? color : 'var(--line)', backgroundColor: active ? `${color}20` : 'transparent' }}
  >
    <span>{name}</span>
  </button>
);

export default FilterButton;
